import { atom } from "jotai";

import { $skipCollab } from "../sync/sync-state.atom";
import type { Invitation, LocalUserRelation, PermissionUpdate } from "./permissions.types";
import { $searchUserQuery } from "./searchusers.atom";

// This is used for the ShareTab.
// This is the pending permissions that we want to apply.
export const $pendingPermissionsAtom = atom(new Map<string, PermissionUpdate>());
$pendingPermissionsAtom.debugLabel = "pendingPermissionsAtom";

export const $localUserPermissions = atom(new Map<string, LocalUserRelation>());
$localUserPermissions.debugLabel = "localUserPermissions";
export const $localInvites = atom([] as Array<Invitation>);
$localInvites.debugLabel = "localInvites";
export const $localWorkspacePermission = atom(null as PermissionUpdate | null);
$localWorkspacePermission.debugLabel = "localWorkspacePermission";

// Resets all ShareTab-related state. Used when the share popover closes.
export const $resetShareTabState = atom(null, (_get, set, documentId: string | undefined) => {
	set($pendingPermissionsAtom, new Map());
	set($localUserPermissions, new Map());
	set($localInvites, []);
	set($localWorkspacePermission, null);
	set($skipCollab(documentId), false);
	set($searchUserQuery.$debouncedValueAtom, "");
});
